import cashCoin from 'assets/icons/cash-coin.svg';
import chervonRigt from 'assets/icons/chevron-right-small.svg';
import { LINK_URL } from 'infrastructure/config/CONSTANTS';
import { PageTitle } from 'presentation/components/PageTitle';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { Link } from 'react-router-dom';
import { CardComponent } from './components/CardComponent';
import { Mock } from './models/Mock';

const CU05601Page = () => {
    const mock: Mock[] = [
        {
            title: 'かんたん査定',
            image: <img src={cashCoin} />,
            description: ['所要時間１分、たった４つの項目を登録す', 'るだけで、匿名・無料で相場価格を調べる', 'ことができます。'],
            redirect: PRIVATE_ROUTES.SUB.CU_056_02,
        },
        {
            title: 'くわしく査定',
            image: <img src={cashCoin} />,
            description: ['詳細な物件情報を登録していただくこと', 'で、より正確な査定額に近づきます。'],
            redirect: PRIVATE_ROUTES.SUB.CU_028_01,
        },
    ];
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-056-01-container"
        >
            <PageTitle title="物件査定" />
            <section>
                <div className="grid-container">
                    {mock.map((element: Mock, index: number) => (
                        <div key={index} tabIndex={index}>
                            <CardComponent {...element} />
                        </div>
                    ))}
                    <div>
                        <a href={LINK_URL.CHECK_ASSESSMENT_METHOD} target="_blank" rel="noopener noreferrer" className="link-component">
                            <div style={{ display: 'flex' }}>
                                <div>査定の流れを確認する</div>
                                <img src={chervonRigt} style={{ width: 16, height: 16 }} />
                            </div>
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CU05601Page;
